module.exports = __webpack_public_path__ + "static/media/pay-by-stripe.8b09f7d8.png";